<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center black--text" outlined>
          模試結果表示
        </v-card>
      </v-col>
    </v-row>
    <!-- 検索用の年度入力 -->
    <v-row dense class="mt-4 mb-4">
      <v-col cols="12" justify="center">
        <v-card class="text-center" color="white">
          <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4">
              <v-autocomplete
                v-model="selectNendo"
                label="年度指定"
                placeholder="年度指定"
                :items="nendoList"
                outlined
                dense
                hide-details="auto"
                background-color="white"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="moshiList"
          :items-per-page="-1"
          hide-default-header
          hide-default-footer
          disable-sort
          mobile-breakpoint="0"
          :loading="isListLoding"
          loading-text="読込中"
        >
          <template #[`item.recode`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-toolbar color="primary" dark dense @click="toggleDetails(item)">
                  <v-toolbar-title class="subtitle-1">
                    {{ item.mosiNm }}
                    <span v-if="item.newFlg" class="text-caption font-weight-bold red--text">
                      NEW
                    </span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-icon>{{ item.displayFlg ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-toolbar>
              </v-col>
            </v-row>
            <div>
              <v-expand-transition>
                <v-card v-if="item.displayFlg == true">
                  <v-card-text  v-if="userKbn == '1'">
                    {{ item.userNm }}さん
                  </v-card-text>
                  <v-card-text>
                    <v-simple-table dense>
                      <thead>
                        <tr>
                          <th cols="4" class="text-left">模試科目</th>
                          <th cols="4" class="text-left">区分</th>
                          <th cols="4" class="text-left">模試成績</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="subject in filteredSubjects(item)" :key="subject.key">
                          <td>{{ subject.mKamokuNm }}</td>
                          <td>{{ subject.dataKbnNm }}</td>
                          <td>{{ subject.mosiSeiseki }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-expand-transition>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import '@uppy/core/dist/style.css';
import { httpsCallable, getFunctions } from 'firebase/functions';
export default {
  data() {
    return {
      selectNendo: "",
      nendoList: [],
      userKbn : "",
      moshiList: [],
      headers: [
        { text: "", value: "recode" },
        { text: "年度", value: "nendo", cellClass: "d-none", filter: this.nendoFilter },
      ],
    };
  },
  // 初期表示時データ読み込み
  async created() {
    await this.load();
  },
  methods: {
    // グループ名フィルタ
    nendoFilter(value) {
      if (!this.selectNendo) {
        return true;
      }
      return value.toString().includes(this.selectNendo);
    },
    async load() {
      // ローディング表示
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = 'asia-northeast1';
      var data = {
        funcName: 'loadPracticeExamHistory',
      };
      const schoolAidHomeLogined = httpsCallable(functions, 'schoolAidHomeLogined');
      await schoolAidHomeLogined(data).then((ret) => {
        this.userKbn = ret.data.userKbn;
        this.selectNendo = ret.data.tounendo;
        this.nendoList = ret.data.nendoList;
        this.moshiList = ret.data.moshiList;
      });

      // ローディング非表示
      this.$root.loading = false;
    },
    // 明細の折り畳み制御
    toggleDetails(item) {
      item.displayFlg = !item.displayFlg;
    },
    // 科目と点数表示制御
    filteredSubjects(item) {
      const subjects = [];
      var kamokuNm = "";
      for (let i = 1; i <= 100; i++) {
        if (item['mKamokuNm' + i] !== null) {
          // 科目名が同じなら空欄
          var mKamokuNm = kamokuNm == item['mKamokuNm' + i] ? "" : item['mKamokuNm' + i];
          subjects.push({
            key: i,
            mKamokuNm: mKamokuNm,
            dataKbnNm: item['dataKbnNm' + i],
            mosiSeiseki: item['mosiSeiseki' + i],
          });
        } else {
          // 科目名がデータなし⇒以降の模試情報を表示しない
          break;
        }
        kamokuNm = item['mKamokuNm' + i];
      }
      return subjects;
    },
  },
};
</script>

<style scoped lang="scss">  
  tbody {
     tr:hover {
        background-color: transparent !important;
     }
  }
</style>